export const cardTransactions = {
  items: [
    {
      transactionId: 1,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    },
    {
      transactionId: 2,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    },
    {
      transactionId: 3,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    },
    {
      transactionId: 4,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    },
    {
      transactionId: 5,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    },
    {
      transactionId: 6,
      vehicleNumber: 'RECIPIENT 32',
      transactionDate: '04/02/22 - 14:30',
      productName: 'Carbune',
      quantity: 1,
      price: 12345,
      priceWithVat: 34567,
      kmNumber: 1645,
      fuelStationName: 'Bucuresti',
      supplierName: 'OMV'
    }
  ],
  total: 6,
  totalPages: 1,
  pageTotalQuantity: 6,
  reportTotalQuantity: 36,
  pageTotalPrice: 12345,
  reportTotalPrice: 34567
};

export const cardTransactionDetails = {
  transactionId: 1,
  vehicleNumber: 'RECIPIENT 32',
  transactionDate: '04/02/22 - 14:30',
  productName: 'Carbune',
  quantity: 1,
  price: 12345,
  priceWithVat: 34567,
  kmNumber: 1645,
  stationName: 'Bucuresti',
  supplierName: 'OMV'
};

export const suppliers = [
  {value: 'GAZ'},
  {value: 'LUK'},
  {value: 'MOL'},
  {value: 'OMV'},
  {value: 'RPT'}
];

export const codeServices = [
  {value: 80},
  {value: 81},
  {value: 82},
  {value: 83},
  {value: 84},
  {value: 85}
];

export const cardNumbers = [
  {value: '**** **** 1234 5678'},
  {value: '**** **** 2345 6789'}
];

export const testValues = [
  {
    cardNumber: '1234 1234',
    cardName: 'Test 1',
    registrationNo: 'VS 01 TTT',
    costCenter: 'AAAAA'
  },
  {
    cardNumber: '1234 9999',
    cardName: 'Test 2',
    registrationNo: 'VS 01 TTT',
    costCenter: 'BBBBBB'
  },
  {
    cardNumber: '9999 1234',
    cardName: 'Test 3',
    registrationNo: 'VS 444 QQQ',
    costCenter: ''
  },
  {
    cardNumber: '9999 9999',
    cardName: '',
    registrationNo: 'VS 11 xxx',
    costCenter: 'DDDDDD'
  },
  {
    cardNumber: '0000 0000',
    cardName: '',
    registrationNo: '',
    costCenter: 'XXXXXX'
  }
];
